import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'customerinfo.client_number')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'customerinfo.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'info.last_name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'info.first_name')} /></TableCell>
</>

export default React.memo(Row)
